import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { usePagination } from '@webapp/core/hooks/usePagination'
import { CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { creditCardItemQueries } from '@webapp/modules/accounts-payable/query-configs/creditCardItemQueries'

interface IUseQueryUnmatchedCreditCardItemsParams {
  accountId: number
  onError?: (err: unknown) => void
}

interface IUseQueryUnmatchedCreditCardItemsReturn {
  items: CreditCardItem[]
  /** pagination.count — FS tab badge (BHV-030) */
  unmatchedCount: number
  isLoading: boolean
  error: unknown
}

export const useQueryUnmatchedCreditCardItems = ({
  accountId,
  onError,
}: IUseQueryUnmatchedCreditCardItemsParams): IUseQueryUnmatchedCreditCardItemsReturn => {
  const { params, updateNumPages } = usePagination({
    id: 'ap-reconcile-unmatched-items',
  })

  const { data, isLoading, error } = useQuery({
    ...creditCardItemQueries.unmatched({
      creditcardId: accountId,
      orderBy: params.orderBy,
      search: params.search,
      page: params.page,
      pageSize: params.pageSize,
    }),
    onSuccess: (res) => {
      updateNumPages(res.pagination.numPages)
    },
    onError,
  })

  const items = useMemo(
    () =>
      (data?.items ?? []).map((constructor) => new CreditCardItem(constructor)),
    [data]
  )

  return {
    items,
    unmatchedCount: data?.pagination.count ?? 0,
    isLoading,
    error,
  }
}
